import { ColumnInstance } from "react-table";

import { XMarkIcon } from "@heroicons/react/20/solid";

import { Button } from "../Button";
import { SearchFilter } from "./components/SearchFilter";

export function TableFilters<TRowData extends object>(props: {
  columns: ColumnInstance<TRowData>[];
  searchTerm: string;
  onSearchChange: (searchTerm: string) => void;
  onResetFilters: () => void;
  isFiltered?: boolean;
}) {
  return (
    <div className="flex flex-wrap gap-x-2 gap-y-2">
      <div className="flex w-full items-end xs:w-36 sm:w-60">
        <SearchFilter
          searchTerm={props.searchTerm}
          onChange={props.onSearchChange}
        />
      </div>
      {props.columns.map((column) => {
        if (column.canFilter && column.Filter) {
          return <div key={column.id}>{column.render("Filter")}</div>;
        }
        return null;
      })}
      <div className="self-end">
        <Button
          size="sm"
          variant="ghost"
          onClick={() => props.onResetFilters()}
          isDisabled={!props.isFiltered}
          iconRight={<XMarkIcon className="ml-1" />}
          className="text-sm"
        >
          Reset
        </Button>
      </div>
    </div>
  );
}
